<template>
  <div class="dorm-tab__left mycursorPointer">
    <div v-on:click="goPageAll()"
      :to="{ name: 'University', params: { slug: this.$route.params.slug } }"
      v-if="$route.params.type || $route.params.faculty" class="dorm-tab__button">
      <span class="button__wrp">
        <span class="dorm-tab__txt">
          Tümü<literal>nü Gör </literal>
        </span>
      </span>
    </div>
    <div v-on:click="goPage(tab)"
      class="dorm-tab__button mycursorPointer"
      v-for="tab in tabs2" :key="tab.id"
      :class="[{ active : tab.typeID === checkGender }, tab.cat ]">
        <span class="button__wrp">
          <span class="dorm-tab__icon">
            <img :src="tab.icon" alt="" class="icon">
          </span>
          <span class="dorm-tab__txt">
            <span v-html="tab.title">{{tab.title}}</span>
          </span>
        </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DormTabNav',
  props: {
    tabs: Array
  },
  data () {
    return {
      currentTab: null,
            tabs2: [
        {
          id: 2,
          typeID: 2,
          cat: 'female',
          title: '<span class="color-pink">Kız <literal> Öğrenci Yurtları </literal>',
          icon: require('@/assets/img/icon-female.svg'),
          active: false
        },
        {
          id: 1,
          typeID: 1,
          cat: 'male',
          title: '<span class="color-blue">Erkek <literal> Öğrenci Yurtları </literal>',
          icon: require('@/assets/img/icon-male.svg'),
          active: false
        }
      ]
    }
  },
  methods: {
    select (tab) {
      this.currentTab = tab
    },
    
    goPageAll(tab) {
     window.localStorage.setItem('list', 'university')
     window.localStorage.setItem('faculty_id', '')
     window.localStorage.setItem('faculty_name', '')
    window.localStorage.setItem('district_name', '')
     let route = { name: 'University', params: { slug: this.$route.params.slug } }
/*       let gender = 'erkek'
      if(tab.typeID === 2 ) {
        gender = 'kiz'
      }
      let route = ''
      if (this.$route.params.faculty) {
       route = this.$route.params.slug + '--' + this.$route.params.faculty + '--' + gender + '-ogrenci-yurtlari/' 
      } else {
        route = this.$route.params.slug + '-yakin-' + gender + '-ogrenci-yurtlari/'
      } */
      this.$router.push(route)
    },    
    goPage(tab) {
      let gender = 'erkek'
      if(tab.typeID === 2 ) {
        gender = 'kiz'
        window.localStorage.setItem('gender_name', 'Kız Öğrenci Yurdu')
      } else {
        window.localStorage.setItem('gender_name', 'Erkek Öğrenci Yurdu')
      }
      let route = ''
        window.localStorage.setItem('typeID', tab.typeID)

      if (this.$route.params.faculty) {
       route = this.$route.params.slug + '--' + this.$route.params.faculty + '--' + gender + '-ogrenci-yurtlari/' 
      } else {
        route = this.$route.params.slug + '-yakin-' + gender + '-ogrenci-yurtlari/'
      }
      this.$router.push('/' + route)
    },
    generateUrl (tab) {
      let route
      if (tab.typeID === 1) {
        if (this.$route.params.faculty) {
          route = { name: 'UniversityFacultyGender', params: { type: 'erkek' } }
        } else {
          route = { name: 'UniversityGender', params: { type: 'erkek' } }
        }
      } else if (tab.typeID === 2) {
        if (this.$route.params.faculty) {
          route = { name: 'UniversityFacultyGender', params: { type: 'kiz' } }
        } else {
          route = { name: 'UniversityGender', params: { type: 'kiz' } }
        }
      }
      return route
    },
    clearFilter () {
      // this.$router.push({ name: 'City', params: { slug: this.$route.params.slug } })
      this.currentTab = null
    }
  },
  computed: {
    checkGender () {
      let typeID
      if (this.$route.params.type === 'erkek') {
        typeID = 1
      } else if (this.$route.params.type === 'kiz') {
        typeID = 2
      }
      return typeID
    }
  }
}
</script>

<style scoped>
  .mycursorPointer { 
    cursor: pointer; 
    }
</style>
